import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionReservationHideMailMagazineQuestion } from "./hide-mail-magazine-question";
import { QuestionReservationBasePolicyPreQuestions as QuestionPreQuestions } from "./pre-questions";

import type { HotelPolicyCategoriesAndManagerStore } from "../../../../store/categories";

type Props = {
	reservationQuestionSettings: HotelPolicyCategoriesAndManagerStore["reservationQuestionSettings"];
};

export const QuestionReservationQuestionSettings = ({ reservationQuestionSettings }: Props) => {
	return (
		<>
			<FeatureIslandMainWithCategoryWrapper categoryStore={reservationQuestionSettings}>
				<QuestionPreQuestions />
			</FeatureIslandMainWithCategoryWrapper>
			<FeatureIslandMainWithCategoryWrapper
				islandTitle="メルマガ設定"
				categoryStore={reservationQuestionSettings}
			>
				<QuestionReservationHideMailMagazineQuestion />
			</FeatureIslandMainWithCategoryWrapper>
		</>
	);
};

QuestionReservationQuestionSettings.displayName = "QuestionReservationQuestionSettings";
